import React, { useState } from "react";
import cn from "classnames";
import { Link } from "react-router-dom";
import styles from "./control.module.sass";
import Modal from "../../../../../../../components/Modals/ModalComponent";
import Icon from "../../../../../../../components/Icon";
import Payout from "../../../../../../../components/BuildComponents/RMC/Modals/Payout";

const Control = ({className, size}) => {

  const [visibleModal, setVisibleModal] = useState(false);

  return (
    <>
      <div className={cn(styles.control)}>
        <button className={cn(styles.button, {[styles.large] : (size === 'large')})} onClick={() => setVisibleModal(true)}>
          <div className={styles.add}>
            <Icon className={styles.addIcon} name='plus-circle' size='16' />
          </div>
          <div className={styles.title}>{size === 'large' ? 'Create Payout' : 'Create'}</div>
        </button>
      </div>
      <Modal width='large' visible={visibleModal} onClose={() => setVisibleModal(false)}>
        <Payout onClose={() => setVisibleModal(false)}/>
      </Modal>
    </>
  );
};

export default Control;
